import { motion } from "framer-motion";

import { useDispatch, useSelector } from "react-redux";

import { changeIsMiniSidenav } from "theme/redux";

import { Typography } from "@mui/material";

import { ReactComponent as MBSWhite } from "assets/svg/MBSWhite.svg";
import { ReactComponent as IconChevronLeft } from "assets/svg/chevron-left.svg";
import { ReactComponent as Logo } from "assets/svg/logo.svg";

import { themesSelector } from "theme/selector";

import { LogoWrapper, MiniMenuButton, NavbarHeader } from "./style";

const LogoMBS = () => {
  const dispatch = useDispatch();

  const { isMiniSidenav, isMiniWindow } = useSelector(themesSelector);

  const handleUnMiniMenu = () => {
    dispatch(changeIsMiniSidenav(false));
  };
  const handleMiniMenu = () => {
    dispatch(changeIsMiniSidenav(true));
  };
  return (
    <NavbarHeader isMiniSideNav={isMiniSidenav}>
      <LogoWrapper isMiniSideNav={isMiniSidenav}>
        {!isMiniWindow &&
          (isMiniSidenav ? (
            <motion.div
              key="logo"
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 10 }}
              transition={{ duration: 0.3 }}
            >
              <Logo />
            </motion.div>
          ) : (
            <>
              <motion.div
                key="mbswhite"
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 10 }}
                transition={{ duration: 0.3 }}
              >
                <MBSWhite />
              </motion.div>
              <motion.div
                key="portal"
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 10 }}
                transition={{ duration: 0.3 }}
              >
                <Typography
                  color="ButtonHighlight"
                  fontSize={isMiniSidenav ? 12 : 20}
                >
                  IPORTAL
                </Typography>
              </motion.div>
            </>
          ))}
      </LogoWrapper>

      {!isMiniWindow && (
        <MiniMenuButton
          onClick={isMiniSidenav ? handleUnMiniMenu : handleMiniMenu}
          animate={{ rotate: isMiniSidenav ? 180 : 0 }}
          transition={{ duration: 0.3 }}
        >
          <IconChevronLeft />
        </MiniMenuButton>
      )}
    </NavbarHeader>
  );
};

export default LogoMBS;
